import { useCallback, useEffect, useState } from "react";
import { User } from "../../models/user";
import Api from "../../services/api";

//Retrieves profile given userID (username/address)
export const useProfile = (userID: string): [User, boolean, any] => {
  const [user, setUser] = useState<User>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<any>();
  useEffect(() => {
    const api = new Api();

    api
      .getProfile(userID)
      .then((response) => {
        if (response.address) {
          setUser(response);
        } else {
          setError(response);
        }
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [userID]);

  return [user, loading, error];
};
